export const InputVariant ={
   
        initial:{
            width:0
        },
        then:{
            width:"100%",
            transition:{
                duration: .3,
                delay: 0.1
            }
        },
        exit:{
            width:0,
            transition:{
                duration: .3,
                delay: 0.1,
                
            }
        }
       
}